import { AUDIO_TONES_BY_CHANNEL, DEFAULT_AUDIO_TONE_BY_CHANNEL } from "src/components/common/AudioSettings/constants/audioCatalog";
import { getAudioPreferenceKey } from "src/components/common/AudioSettings/helpers/getAudioPreferenceKey";
import { playAudioTone } from "src/components/common/AudioSettings/helpers/playAudioTone";
import { AudioChannelPreference } from "src/components/common/AudioSettings/types";

const THROTTLE_MS = 1500;
const DEFAULT_VOLUME = 80;

let lastPlayedAt = 0;
let activeCallAudio: HTMLAudioElement | null = null;
let activeCallToneId: string | null = null;

const readMessagePreference = (accountId?: string | number | null): AudioChannelPreference => {
  const key = getAudioPreferenceKey({
    channel: "message",
    scope: "account",
    accountId,
  });

  try {
    const stored = window.localStorage.getItem(key);
    if (!stored) {
      return {
        toneId: DEFAULT_AUDIO_TONE_BY_CHANNEL.message,
        volume: DEFAULT_VOLUME,
      };
    }

    const parsed = JSON.parse(stored);

    return {
      toneId: typeof parsed?.toneId === "string" ? parsed.toneId : DEFAULT_AUDIO_TONE_BY_CHANNEL.message,
      volume: typeof parsed?.volume === "number" ? parsed.volume : DEFAULT_VOLUME,
    };
  } catch {
    return {
      toneId: DEFAULT_AUDIO_TONE_BY_CHANNEL.message,
      volume: DEFAULT_VOLUME,
    };
  }
};

const readCallPreference = (companyId?: string | number | null): AudioChannelPreference => {
  const key = getAudioPreferenceKey({
    channel: "call",
    scope: "company",

    companyId,
  });

  try {
    const stored = window.localStorage.getItem(key);
    if (!stored) {
      return {
        toneId: DEFAULT_AUDIO_TONE_BY_CHANNEL.call,
        volume: DEFAULT_VOLUME,
      };
    }

    const parsed = JSON.parse(stored);

    return {
      toneId: typeof parsed?.toneId === "string" ? parsed.toneId : DEFAULT_AUDIO_TONE_BY_CHANNEL.call,
      volume: typeof parsed?.volume === "number" ? parsed.volume : DEFAULT_VOLUME,
    };
  } catch {
    return {
      toneId: DEFAULT_AUDIO_TONE_BY_CHANNEL.call,
      volume: DEFAULT_VOLUME,
    };
  }
};

export const playConfiguredMessageSound = (accountId?: string | number | null): void => {
  if (typeof window === "undefined") return;

  const now = Date.now();
  if (now - lastPlayedAt < THROTTLE_MS) return;

  const preference = readMessagePreference(accountId);
  const tone = AUDIO_TONES_BY_CHANNEL.message.find((item) => item.id === preference.toneId);
  if (!tone || tone.id === "silent") return;

  // Sonido configurado para los mensajes.
  lastPlayedAt = now;

  try {
    void playAudioTone(tone, preference.volume / 100).catch(() => {});
  } catch {
    console.error("Failed to play new message sound");
  }
};

export const stopConfiguredCallSound = (): void => {
  if (!activeCallAudio) return;

  activeCallAudio.pause();
  activeCallAudio.currentTime = 0;
  activeCallAudio = null;
  activeCallToneId = null;
};

export const playConfiguredCallSound = (companyId?: string | number | null): void => {
  if (typeof window === "undefined") return;

  const preference = readCallPreference(companyId);
  const tone = AUDIO_TONES_BY_CHANNEL.call.find((item) => item.id === preference.toneId);

  stopConfiguredCallSound();

  if (!tone || tone.id === "silent" || !tone.src) return;

  // Sonido configurado para llamadas entrantes.
  activeCallToneId = tone.id;
  activeCallAudio = new Audio(tone.src);
  activeCallAudio.loop = true;
  activeCallAudio.volume = Math.min(Math.max(preference.volume / 100, 0), 1);
  activeCallAudio.currentTime = 0;

  void activeCallAudio.play().catch(() => {
    if (activeCallToneId === tone.id) {
      stopConfiguredCallSound();
    }
  });
};
